import * as yup from 'yup'
import css from './pages.module.css'
import { disclosurePermission } from '../choices'
import { IdentityConsent } from '../components/IdentityConsent'
import { selectionRequired } from '../validators'

export const permissionToDisclosePage = propOverrides => {
  const props = {
    pageId: 'permission_to_disclose_page',
    fieldName: 'perm_to_disclose',
    pageTitle: 'Consent to disclose your identity',
    className: css.choices,
    labelClassName: css.largeLabel,
    choices: 'all',
    validation: null,
    ...propOverrides
  }

  // By default, at least one choice must be selected.
  if (props.validation === null)
    props.validation = yup.object().shape({
      [props.fieldName]: selectionRequired()
    })

  return {
    id: props.pageId,
    title: props.pageTitle,
    validation: props.validation,
    fields: [
      {
        type: 'content',
        content: IdentityConsent
      },
      {
        type: 'radio',
        className: css.choices,
        label: '',
        name: props.fieldName,
        choices:
          props.choices === 'non_anon'
            ? disclosurePermission().slice(0, 2)
            : disclosurePermission()
      }
    ]
  }
}
